export function calculateMediaDimensions(content, parentWidth, containerPaddingWidth, windowHeight, maxWidthFraction = 0.8) {
    const ratio = content.height / content.width;
    const availWidth = parentWidth * maxWidthFraction - containerPaddingWidth;
    const availHeight = Math.min((2 * windowHeight) / 3, 400);
    let width = Math.min(availWidth, Math.max(200, content.width));
    let height = width * ratio;
    if (height > availHeight) {
        height = availHeight;
        // Allow the image to be stretched in this rare case
        width = Math.max(90 - containerPaddingWidth, height / ratio);
    }
    return {
        width,
        height,
    };
}
